export default "__VITE_ASSET__B4cw1CtP__"